import { useGeo } from '@features/geo/use-geo'
import { needKeysGeo } from '@features/needs/model/query-keys'
import { useNeedsInfiniteQuery } from '../useNeedsInfiniteQuery'

export function useGeoNeedsQuery(
  props: { enabled?: boolean; need_tags?: string[]; forHome?: boolean } = {
    enabled: true,
  }
) {
  const geo = useGeo()
  const latitude = geo?.latitude ?? 0
  const longitude = geo?.longitude ?? 0

  const queryKey = props.forHome
    ? needKeysGeo.homePoint(latitude, longitude, props.need_tags)
    : needKeysGeo.point(latitude, longitude, props.need_tags)

  return useNeedsInfiniteQuery({
    ...queryKey,
    enabled:
      props.enabled &&
      typeof window !== 'undefined' &&
      !!latitude &&
      !!longitude,
  })
}
